// extracted by mini-css-extract-plugin
export var active = "techstacks-module--active--fcfc9";
export var liDiv = "techstacks-module--liDiv--40387";
export var swiperBox = "techstacks-module--swiperBox--16a31";
export var techstacks_info = "techstacks-module--techstacks_info--f9a9c";
export var techstacks_listing = "techstacks-module--techstacks_listing--85789";
export var techstacks_wrap = "techstacks-module--techstacks_wrap--fea77";